module.exports = __webpack_public_path__ + "static/media/play_store.6dcf9d9f.png";